export interface EbtronInputs {
  minDisplayed: number;
  minActual: number;
  maxDisplayed: number;
  maxActual: number;
  ductArea: number;
  midrangeActual?: number;
}

export interface EbtronCalcResult {
  gain: number;
  offsetCfm: number;
  offsetFpm: number;
  midrangeDisplayed: number;
  midrangeAccuracyPct?: number;
  midrangePass?: boolean;
}

export function calculateEbtronCalibration(inputs: EbtronInputs): EbtronCalcResult | null {
  const { minDisplayed, minActual, maxDisplayed, maxActual, ductArea, midrangeActual } = inputs;
  const displayedDiff = maxDisplayed - minDisplayed;
  if (Math.abs(displayedDiff) < 0.001 || ductArea === 0) return null;

  const gain = (maxActual - minActual) / displayedDiff;
  const offsetCfm = minActual - gain * minDisplayed;
  const offsetFpm = offsetCfm / ductArea;
  const midrangeDisplayed = (minDisplayed + maxDisplayed) / 2;

  let midrangeAccuracyPct: number | undefined;
  let midrangePass: boolean | undefined;
  if (midrangeActual !== undefined && Math.abs(midrangeDisplayed) > 0.1) {  // fix B-9: guard near-zero to prevent accuracy% explosion; B-4: undefined check
    midrangeAccuracyPct = Math.abs((midrangeActual - midrangeDisplayed) / midrangeDisplayed) * 100;
    midrangePass = midrangeAccuracyPct <= 2.0;
  }

  return { gain, offsetCfm, offsetFpm, midrangeDisplayed, midrangeAccuracyPct, midrangePass };
}
